module.exports = "/_next/static/images/avatar-frame-tier-0--simple-25a22c696671fc46d6fcf55c723fe6f4.png";